import { createComponent } from '@carvana/merch-components';
import { CommonSection } from '~/components/flp/Financing.styles';

export const ErrorSection = createComponent(CommonSection, {
  className: 'bg-canvas-muted'
});

export const Container = createComponent('div', {
  className: 'flex min-h-[40vh] flex-col items-center justify-center'
});

export const Heading = createComponent('h1', {
  className: 'text-center text-text-primary'
});

export const Description = createComponent('p', {
  className: 'my-2 mt-2 text-text-secondary mb-4 text-center'
});

export const ButtonContainer = createComponent('div', {
  className: 'mt-4 flex gap-4'
});
